import type { HotelId } from '@lt/api/dist/types/hotels';
import { createAction } from '@reduxjs/toolkit';

import { name } from './slice';

export const fetchHotelImagesAction = createAction<HotelId>(
  `${name}/fetchImages`,
);
